<!--Renderiza cuando está en modo claro-->
<div class="flex flex-col justify-between items-stretch container-fluid imagen-fondo bg-logo-light dark:hidden"
    style="height: 90vh !important;">
    <ng-container *ngTemplateOutlet="contenido"></ng-container>
</div>

<!--Renderiza cuando está en modo oscuro-->
<div class="hidden imagen-fondo bg-logo-dark dark:flex flex-col justify-between items-stretch container-fluid"
     style="height: 90vh !important;">
    <ng-container *ngTemplateOutlet="contenido"></ng-container>
</div>

<ng-template #contenido>
    <div fxLayout="row" fxLayoutAlign="center" class="mt-12 ml-5 md:ml-0 border-gray-100 border-b-2">
        <p class="text-4xl font-sans font-bold text-black dark:text-white">¡Bienvenido, {{usuario}}!</p>
    </div>
    <div fxLayout="row">
        <img class="w-full" src="assets/images/separador.svg" alt="Separador">
    </div>
</ng-template>
